import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { emitter } from '@/plugins/emitter'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import type {
  AtenaCharLimits,
  AtenaItem
} from '@/utils/format-edit/atenaFormat'


export default /*#__PURE__*/_defineComponent({
  __name: 'AtenaItemsCard',
  props: {
    atenaItems: null,
    maxAtenaItems: null,
    charLimits: null
  },
  emits: ["add", "delete"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'add'): void
  (e: 'delete', index: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  // 親(AtenaEdit)所有の配列。項目フィールドの編集は参照経由、追加・削除は emit で親が行う
  atenaItems: AtenaItem[]
  maxAtenaItems: number
  charLimits: AtenaCharLimits
};





const { formLib } = useHostServices()

const activeHistoryItem = ref('')

function activateHistoryItem(id: string) {
  activeHistoryItem.value = id
}

function deactivateHistoryItem() {
  activeHistoryItem.value = ''
}

function isOverLimit(text: string | undefined, field: keyof AtenaCharLimits) {
  if (!text) return false
  return text.length > props.charLimits[field]
}

function cleanUpPostNumber(value: string | undefined) {
  if (!value) return ''
  return String(formLib.zenToHanNumber(value.replace(/-/g, '')))
}

onMounted(() => {
  emitter.on('deactivate-history-item', deactivateHistoryItem)
})

onBeforeUnmount(() => {
  emitter.off('deactivate-history-item', deactivateHistoryItem)
})

return { __sfc: true,props, emit, formLib, activeHistoryItem, activateHistoryItem, deactivateHistoryItem, isOverLimit, cleanUpPostNumber }
}

})